// örn: src/config/axiosSetup.js
import axios from "axios";

let islemId = null;

export function getIslemId() {
  // if (!islemId) islemId = crypto.randomUUID();
  return islemId;
}

export function resetIslemId() {
  islemId = null;
  delete axios.defaults.headers.common['X-Query-Id'];
}

axios.interceptors.request.use((config) => {
  const queryId = getIslemId();
  if (queryId) {
    config.headers["X-Query-Id"] = queryId;
  }
  return config;
});

axios.interceptors.response.use((response) => {
  const gelenId = response.headers['X-Query-Id'];
  if (gelenId) {
    islemId = gelenId; // artık sonraki isteklerde bu kullanılır
  }
  return response;
});
